const NumberRangeInput = ({
  question,
  className,
  onChange,
  handleBlur,
  value,
}) => {
  let columnData = {
    minNum: 0,
    maxNum: 10,
  };

  try {
    const parsedData = JSON.parse(question.other_column_data);
    if (parsedData) {
      columnData = {
        ...columnData,
        ...parsedData,
      };
    }
  } catch (error) {
    // Fall back to the default range when the config is unavailable.
  }

  const minValue = Number(columnData.minNum);
  const maxValue = Number(columnData.maxNum);

  const canBecomeValidValue = (nextValue) => {
    if (!Number.isInteger(minValue) || !Number.isInteger(maxValue)) {
      return true;
    }

    if (!/^\d+$/.test(nextValue)) {
      return false;
    }

    const parsedValue = Number(nextValue);
    if (parsedValue >= minValue && parsedValue <= maxValue) {
      return true;
    }

    const maxDigits = String(Math.max(minValue, maxValue)).length;

    for (
      let extraDigits = 0;
      extraDigits <= maxDigits - nextValue.length;
      extraDigits++
    ) {
      const multiplier = 10 ** extraDigits;
      const candidateMin = parsedValue * multiplier;
      const candidateMax = ((parsedValue + 1) * multiplier) - 1;

      if (candidateMax >= minValue && candidateMin <= maxValue) {
        return true;
      }
    }

    return false;
  };

  const handleNumberRangeChange = (e) => {
    const nextValue = e.target.value;

    if (nextValue === "") {
      onChange(e);
      return;
    }

    if (Number.isNaN(Number(nextValue))) {
      return;
    }

    if (!canBecomeValidValue(nextValue)) {
      return;
    }

    onChange(e);
  };

  return (
    <>
      <p>{question.question_help}</p>
      <input
        key={`question-${question.id}`}
        name={`question-${question.id}`}
        className={className}
        onChange={handleNumberRangeChange}
        onBlur={handleBlur}
        value={value}
        type="number"
        placeholder="Please enter a number"
        min={minValue}
        max={maxValue}
      />
    </>
  );
};

export default NumberRangeInput;
